import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "table-auto border border-gray-300 text-center align-middle w-full" }
const _hoisted_2 = { class: "bg-brown-gradient text-white text-lg leading-[24px] font-semibold" }
const _hoisted_3 = { class: "h-12" }
const _hoisted_4 = ["rowspan"]
const _hoisted_5 = { class: "border px-4 py-2" }
const _hoisted_6 = { class: "max-w-96" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = ["rowspan"]
const _hoisted_9 = { class: "text-[#dd6c1b]" }
const _hoisted_10 = { class: "max-w-96" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "border px-4 py-2" }
const _hoisted_13 = { class: "max-w-96" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = { class: "border p-2 size-10" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "max-w-96 text-left" }
const _hoisted_18 = { class: "border px-4 py-2" }
const _hoisted_19 = { class: "max-w-96" }
const _hoisted_20 = { class: "text-left" }

import { computed } from "vue";
import { elementStageNames, tenGods, ownerOrder } from "@/constants/bazi";
import { elColor } from "@/constants/colors";
import { Hidden } from "@/types/calculators";
import AppTooltip from "@/components/AppTooltip.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalHiddenDesktop',
  props: {
    hidden: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const groupedHidden = computed(() => {
  return ownerOrder
    .map((owner) => ({
      owner,
      label: "calculators.bazi.results.birthday-map.times." + owner,
      items: props.hidden.filter((h) => h.owner === owner),
    }))
    .filter((group) => group.items.length > 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("th", { class: "opacity-0 w-[1px]" }, "#", -1)),
        _createElementVNode("th", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.heaven-stem")), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.earth-branch")), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.stage")), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.element")), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.god")), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedHidden.value, (group) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: group.owner
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (row, idx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: group.owner + idx
            }, [
              (idx === 0)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    rowspan: group.items.length,
                    class: "font-semibold align-middle border px-3 py-2 text-brown"
                  }, _toDisplayString(_unref(t)(group.label)), 9, _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(AppTooltip, null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("h4", {
                      class: _normalizeClass(_unref(elColor)[row.element])
                    }, _toDisplayString(row.stem), 3)
                  ]),
                  popper: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h5", null, _toDisplayString(row.labels.stem), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(row.tips.stem), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              (idx === 0)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    rowspan: group.items.length,
                    class: "font-semibold align-middle border px-3 py-2"
                  }, [
                    _createVNode(AppTooltip, null, {
                      trigger: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_9, _toDisplayString(row.branch), 1)
                      ]),
                      popper: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h5", null, _toDisplayString(row.labels.branch), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(row.tips.branch), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ], 8, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_12, [
                _createVNode(AppTooltip, null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("h4", {
                      class: "mb-0",
                      style: _normalizeStyle(`color: ${_unref(elementStageNames)[row.stage]['color']}`)
                    }, _toDisplayString(row.stage), 5)
                  ]),
                  popper: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h5", null, _toDisplayString(row.labels.stage), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(row.tips.stage), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createVNode(AppTooltip, null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("img", {
                      src: 
                      require(`@/assets/calculators/bazi/${row.element}.png`)
                    ,
                      alt: row.element,
                      class: "py-1 size-14"
                    }, null, 8, _hoisted_16)
                  ]),
                  popper: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(row.tips.element), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("td", _hoisted_18, [
                _createVNode(AppTooltip, null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("h4", {
                      class: "mb-0",
                      style: _normalizeStyle(`color: ${_unref(tenGods)[row.god]['color']}`)
                    }, _toDisplayString(row.god), 5)
                  ]),
                  popper: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h5", null, _toDisplayString(row.labels.god), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(row.tips.god), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
}
}

})